export const isAdvancePaymentRequired = (tripType) =>
  tripType !== 'rental' && tripType !== 'instant';
